import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import useNcrStore from '../store/ncrStore';
import useUIStore from '../store/uiStore';
import ScrollX from '../components/ScrollX';

const statusColors = {
  open: 'bg-gray-200 text-gray-800',
  under_review: 'bg-amber-100 text-amber-800',
  dispositioned: 'bg-blue-100 text-blue-800',
  closed: 'bg-green-100 text-green-800',
};

const severityColors = {
  low: 'text-green-600',
  medium: 'text-amber-600',
  high: 'text-red-600',
};

const NCRListPage = () => {
  const { ncrReports, isLoading, error, fetchNCRs } = useNcrStore();
  const showToast = useUIStore((s) => s.showToast);

  useEffect(() => {
    fetchNCRs();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (error) showToast(error, 'error');
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [error]);

  const handleFilterChange = (e) => {
    const value = e.target.value || undefined;
    fetchNCRs(value ? { status: value } : {});
  };

  return (
    <div className="min-h-screen p-6">
      <div className="max-w-5xl mx-auto">
        <div className="flex items-center justify-between mb-6 flex-wrap gap-3">
          <h1 className="text-2xl font-bold text-white">NCR Reports</h1>
          <div className="flex items-center gap-3">
            <select
              onChange={handleFilterChange}
              defaultValue=""
              className="border border-gray-300 rounded px-3 py-2 text-sm"
            >
              <option value="">All statuses</option>
              <option value="open">Open</option>
              <option value="under_review">Under Review</option>
              <option value="dispositioned">Dispositioned</option>
              <option value="closed">Closed</option>
            </select>
            <Link
              to="/ncr/create"
              className="bg-komal-blue hover:bg-komal-blue-dark text-white text-sm font-semibold px-4 py-2 rounded"
            >
              + Raise NCR
            </Link>
          </div>
        </div>

        <div className="glass-card">
          {isLoading ? (
            <p className="text-gray-500 text-sm p-5">Loading...</p>
          ) : ncrReports.length === 0 ? (
            <p className="text-gray-500 text-sm p-5">No NCRs raised yet.</p>
          ) : (
            <ScrollX>
            <table className="w-full text-sm">
              <thead>
                <tr className="text-left text-gray-500 border-b border-gray-100">
                  <th className="px-5 py-2 font-medium">NCR #</th>
                  <th className="px-5 py-2 font-medium">Description</th>
                  <th className="px-5 py-2 font-medium">Severity</th>
                  <th className="px-5 py-2 font-medium">Status</th>
                  <th className="px-5 py-2 font-medium"></th>
                </tr>
              </thead>
              <tbody>
                {ncrReports.map((n) => (
                  <tr key={n.id} className="border-b border-gray-50 last:border-0">
                    <td className="px-5 py-3 font-mono text-xs">{n.ncr_number}</td>
                    <td className="px-5 py-3 max-w-xs truncate">{n.description}</td>
                    <td className={`px-5 py-3 capitalize font-medium ${severityColors[n.severity]}`}>{n.severity}</td>
                    <td className="px-5 py-3">
                      <span className={`px-2 py-1 rounded text-xs font-semibold capitalize ${statusColors[n.status]}`}>
                        {n.status.replace('_', ' ')}
                      </span>
                    </td>
                    <td className="px-5 py-3">
                      <Link to={`/ncr/${n.id}`} className="text-komal-blue hover:underline text-xs font-semibold">
                        View
                      </Link>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            </ScrollX>
          )}
        </div>
      </div>
    </div>
  );
};

export default NCRListPage;
